module.exports = __webpack_public_path__ + "static/img/inscora-logo.1a097ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inscora-logo.jpg
// module id = ePJs
// module chunks = 2